module.exports = __webpack_public_path__ + "img/second-day-12.fe296b3a.png";